import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/advancedMathReference';

export default function AdvancedMathReference() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="Quick-lookup formulas and rules for Advanced Math — exponent rules, factoring patterns, the quadratic formula, function transformations, and exponential growth and decay."
      parts={parts}
    />
  );
}
